import React from 'react'

export default function Eyedetect() {
  return (
    <div>
      Eyedetect
    </div>
  )
}
